{
  "id": "campaign-137",
  "name": "Champions Bowl",
  "seed": "campaign:137",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "r.....QQQQ.....r",
    "..a:a......a:a..",
    ".x.:........:...",
    "...::::::::::...",
    ".......,......#.",
    "..a.a.,,,..a.a..",
    "......a,.a......",
    ".a..a......a..a.",
    "................",
    "::::::::::::::::",
    "...,,,.~~~.....#",
    "....,..~~.......",
    "..,...~.~.......",
    ".,,.........x.,,",
    "#.,::::::::::..,",
    "...:..a..a..:...",
    "...:........:...",
    "......QQQQ.....S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 14,
      "y": 9
    },
    {
      "kind": "rabbit",
      "x": 0,
      "y": 10
    },
    {
      "kind": "rabbit",
      "x": 8,
      "y": 16
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 9,
      "y": 11
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 2,
      "y": 17
    },
    {
      "kind": "gas",
      "x": 3,
      "y": 11
    },
    {
      "kind": "gas",
      "x": 0,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 7,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 0
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 15,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 10
    }
  ],
  "moles": {
    "hills": 4,
    "first": 30,
    "every": 20
  },
  "balls": {
    "first": 18,
    "every": 11
  },
  "generatorVersion": 3,
  "level": 137,
  "biome": "stadium",
  "par": {
    "reel": 9803,
    "push": 8146,
    "selfPropelled": 7680,
    "tractor": 6490,
    "zeroTurn": 5505,
    "fairway": 3707
  },
  "goldTime": {
    "reel": 9293,
    "push": 8146,
    "selfPropelled": 7680,
    "tractor": 6340,
    "zeroTurn": 5462,
    "fairway": 3196
  },
  "routeTries": {
    "par": {
      "reel": 6,
      "push": 15,
      "selfPropelled": 22,
      "tractor": 3,
      "zeroTurn": 21,
      "fairway": 6
    },
    "gold": {
      "reel": 31,
      "push": 15,
      "selfPropelled": 22,
      "tractor": 45,
      "zeroTurn": 37,
      "fairway": 27
    }
  }
}
